import dayjs from "dayjs";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import OTPInput from "react-otp-input";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { Link } from "react-router-dom";
import { store } from "../../../../../utils/redux/store";
import { Divider, Flex } from "antd";

const FinalReview = (props) => {
  const isAdmin = props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  var isReadonly = props.urlparams.params.readonly === "true" ? true : false;
  var tabStatus = props.urlparams.params.status;
  const frompath = props?.urlparams?.params?.frompath;
  const [showRoiModal, setShowRoiModal] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [isOtpDisabled, setIsOtpDisabled] = useState(true);
  const [finalReviewPayload, setFinalReviewPayload] = useState(null);
  const [showAmortCalc, setShowAmortCalc] = useState(true);
  const [amortCalcResponse, setAmortCalcResponse] = useState({});
  const [emiSchedule, setEmiSchedule] = useState([]);
  const modalFields = [
    {
      name: "customerName",
      label: "Applicant Name",
      type: "text",
      readOnly: true,
    },
    {
      name: "customerApplicationType",
      label: "Customer Type",
      type: "select",
      options: _enum.CUSTOMER_TYPES,
    },
    {
      name: "companyname",
      label: "Company Name",
      type: "text",
      readOnly: true,
    },
    {
      name: "companyCategory",
      label: "Company Category",
      type: "text",
      readOnly: true,
    },
    {
      name: "salaryCreditDate",
      label: "Salary Credit Date",
      type: "date",
      dateClassName: "fakedisabled",
    },
    { name: "doj", label: "DOJ", type: "date", readOnly: true },
    {
      name: "overallJobStability",
      label: "Overall Job Stability",
      type: "select",
      options: _enum.PRESENCE_YEAR_KEY,
      readOnly: isAdmin ? true : isReadonly ? true : false,
      required: true,
    },
    {
      name: "applicantDesignation",
      label: "Applicant Designation",
      readOnly: true,
    },
    { name: "cibilScore", label: "Cibil Score", type: "text", readOnly: true },
    {
      name: "residenceStatus",
      label: "Residence Type",
      type: "text",
      readOnly: true,
    },
    {
      name: "residanceStablity",
      label: "Residence Stability",
      type: "select",
      options: _enum.PRESENCE_YEAR_KEY,
      readOnly: isAdmin ? true : isReadonly ? true : false,
      required: true,
    },
    {
      name: "inCityPresence",
      label: "In City Presence",
      type: "select",
      options: _enum.PRESENCE_YEAR_KEY,
      readOnly: isAdmin ? true : isReadonly ? true : false,
      required: true,
    },
    {
      name: "overallCityPresence",
      label: "Overall City Presence",
      type: "select",
      options: _enum.PRESENCE_YEAR_KEY,
      readOnly: isAdmin ? true : isReadonly ? true : false,
      required: true,
    },
    {
      name: "appliedLoanAmount",
      label: "Applied Loan Amount",
      type: "text",
      readOnly: true,
    },
    {
      name: "appliedTenure",
      label: "Applied Tenure",
      type: "text",
      readOnly: true,
    },
    {
      name: "monthlyNetTakeSalary",
      label: "Net Salary",
      type: "number",
      readOnly: true,
    },
    {
      name: "currentObligation",
      label: "Current Obligations",
      type: "number",
      readOnly: true,
    },
    {
      name: "foirCalculation",
      label: "FOIR Calculation",
      type: "number",
      readOnly: true,
    },
    {
      name: "avgMonthlyBalance",
      label: "Avg Bank Balance",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedIRR",
      label: "ROI Offered",
      type: "select",
      options: _enum.ROI_OFFERED,
    },
    {
      name: "eligibleLoanAmt",
      label: "Eligible Loan Amount",
      type: "number",
      required: true,
      readOnly: isAdmin ? true : isReadonly ? true : false,
    },
    {
      name: "sanctionedLoanAmt",
      label: "Final Loan Amount Approved",
      type: "number",
      required: true,
      // onChange: (e) => {
      //   handleLoanAmountChange(e);
      // },
      readOnly: isAdmin ? true : isReadonly ? true : false,
    },
    {
      name: "sanctionedRepayType",
      label: "Product Type",
      type: "select",
      options: _enum.REPAYMENT_TYPE_KEY,
      onChange: (...args) => handleRepaymentChange(...args),
      readOnly: isAdmin ? true : isReadonly ? true : false,
    },
    {
      name: "sanctionedTenure",
      label: "Final Tenure",
      type: "number",
      required: true,
      readOnly: isAdmin ? true : isReadonly ? true : false,
    },
    {
      name: "sanctionedNoOfMonth",
      label: "No. Of EMIs",
      type: "select",
      options: _enum.NO_OF_MONTHS,
    },
    {
      name: "sanctionedLoanStartDate",
      label: "Loan Start Date",
      type: "date",
      required: true,
    },
    {
      name: "sanctionedEMIDate",
      label: "EMI Start Date",
      type: "date",
      required: true,
    },
    {
      name: "sanctionedEMIAmt",
      label: "Final EMI",
      type: "number",
      readOnly: true,
    },
    {
      name: "isDocsRequired",
      label: "Additional Document Required",
      type: "select",
      options: _enum.YES_OR_NO_BOOLEAN,
      onChange: (...args) => handleIsDocsRequiredChange(...args),
      readOnly: isAdmin ? true : isReadonly ? true : false,
    },
    {
      name: "additionalDocsRequested",
      label: "Document Type",
      type: "select",
      options: _enum.DOC_TYPES_NEW_WITH_OTHERS,
      multi: true,
      onChange: (...args) => handleAdditionalDocsChange(...args),
      readOnly: isAdmin ? true : isReadonly ? true : false,
    },
    {
      name: "documentName",
      label: "Document Name",
      type: "text",
      columnClass: "d-none",
      readOnly: isAdmin ? true : isReadonly ? true : false,
    },
    {
      name: "sanctionedPctPF",
      label: "Processing Fees %",
      type: "select",
      options: _enum.PROCESSING_FEE_PERCENTAGES,
      onChange: (...args) => handleProcessingFeePercentage(...args),
      required: true,
      readOnly: isAdmin ? true : isReadonly ? true : false,
    },
    {
      name: "sanctionedPF",
      label: "Processing Fees",
      type: "number",
      step: ".01",
      readOnly: true,
    },
    {
      name: "channel",
      label: "Sourcing Channel",
      type: "select",
      options: _enum.SOURCING_CHANNELS,
      onChange: (...args) => handleSourcingChannelChange(...args),
      readOnly: isAdmin ? true : isReadonly ? true : false,
    },
    {
      name: "dsaName",
      label: "DSA Name",
      type: "text",
    },
    {
      name: "telecallerId",
      label: "Telecaller Name",
      type: "select",
      options: [],
    },
    {
      name: "netDisbursementAmt",
      label: "Net Disbursement Amt", // sanctionedLoanAmt - Processing Fee
      type: "number",
      readOnly: true,
    },
    {
      name: "customerTVRComment",
      label: "Customer TVR Comment",
      type: "text",
      customcolspan: 12,
      readOnly: isAdmin ? true : isReadonly ? true : false,
    },
  ];
  const amortizationColumns = [
    {
      dataIndex: "emiNumber",
      title: "Seq.",
    },
    {
      dataIndex: "date",
      title: "Payment Date",
      render: (text, record) => {
        return <span>{text || "-"}</span>;
      },
    },
    {
      dataIndex: "outstanding",
      title: "Principal Outstanding",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "emi",
      title: "EMI Amount",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "principal",
      title: "Principal",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "interest",
      title: "Interest",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
  ];
  const [amortizationRowcount, setAmortizationRowcount] = useState(0);
  const [fields, setFields] = useState(modalFields);

  const [restructurefields, setRestructurefields] = useState([
    {
      name: "loanAccountNumber",
      label: "Loan Account Number",
      type: "text",
      readOnly: true,
    },
    {
      name: "outstandingAmount",
      label: "Outstanding",
      type: "text",
      readOnly: true,
    },
    { name: "overdue", label: "Overdue", type: "text", readOnly: true },
    {
      name: "restructureWaiver",
      label: "Waiver",
      type: "text",
      readOnly: true,
    },
    {
      name: "restructureSanctionedLoanAmt",
      label: "New Loan Amt",
      type: "text",
      readOnly: true,
    },
    { name: "restructureIRR", label: "ROI", type: "text", readOnly: true },
    {
      name: "restructureTenure",
      label: "Tenure",
      type: "text",
      readOnly: true,
    },
    {
      name: "restructureLoanStartDate",
      label: "New Loan Start Date",
      type: "date",
      readOnly: true,
    },
    {
      name: "restructureLoanEndDate",
      label: "New Loan End Date",
      type: "date",
      readOnly: true,
    },
    {
      name: "remarks",
      label: "Admin Remarks",
      type: "text",
      readOnly: true,
    },
    {
      name: "underwriterRemarks",
      label: "Your Remarks",
      type: "text",
      required: true,
    },
  ]);
  const [hasRestructureData, setHasRestructureData] = useState(false);
  const [reviewdata, setReviewdata] = useState({});

  const handleLoanAmountChange = (e) => {
    let loanAmount = e.target.value;
    let processingFee = loanAmount * 0.1;
    let processignFeeField = fields.find(
      (field) => field.name === "sanctionedPF",
    );
    processignFeeField.defaultValue = processingFee?.toFixed(2);
    let netDisbursementAmtField = fields.find(
      (field) => field.name === "netDisbursementAmt",
    );
    netDisbursementAmtField.defaultValue = Math.ceil(
      Number(loanAmount - processingFee),
    );
    setFields([...fields]);
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
          const result = id.replace(/^column-/, "");
          let input = document.querySelector(`input[name="${result}"]`);
          input?.removeAttribute("required");
          if (
            input?.getAttribute("type") !== "select" &&
            !input.hasAttribute("required")
          ) {
            input.setAttribute("required", true);
          }
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
          const result = id.replace(/^column-/, "");
          let input = document.querySelector(`input[name="${result}"]`);
          input?.removeAttribute("required");
        }
      });
    }
  };

  const handleRepaymentChange = (args) => {
    let repaymentType = args[0]?.key;
    let inputs = [
      "column-sanctionedNoOfMonth",
      "column-sanctionedEMIAmt",
      "column-sanctionedEMIDate",
    ];
    if (repaymentType === "BULLET") {
      hideInputs(inputs);
      showInputs(["column-sanctionedTenure"]);
      setShowAmortCalc(false);
    } else {
      showInputs(inputs);
      hideInputs(["column-sanctionedTenure"]);
      setShowAmortCalc(true);
    }
  };

  const openModal = (modalname) => {
    if (modalname === "roi") {
      setShowRoiModal(true);
    }
  };

  const closeRoiModal = () => {
    setShowRoiModal(false);
  };

  const handleOTPChange = (otp) => {
    // setOTP(otp);
    setOtpValue(otp);
    if (otp.length === 6) {
      setIsOtpDisabled(false);
    } else {
      setIsOtpDisabled(true);
    }
  };

  const handleOtpVerify = (e) => {
    let payload = {
      otpCode: otpValue,
    };
    console.log({ OTP: payload, finalReviewPayload });

    props.apis
      .apiUnderWriterApproveRoiStatus(payload, {
        applicationId: props.urlparams.params.id,
      })
      .then((res) => {
        if (res) {
          console.log({ RoiStatus: res });
          closeRoiModal();
          swal2.fire({
            title: "OTP Submitted Successfully",
            icon: "success",
            iconColor: "#FF4D4D",
            showCancelButton: false,
            timer: 3000,
          });
          navigate(`/app/loanapplications?activetab=${tabStatus}`, {
            replace: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const resendOTP = () => { };

  const handleSourcingChannelChange = (args) => {
    let soruceType = args[0]?.key;
    console.log({ soruceType });
    let inputs = ["column-dsaName"];
    if (soruceType === "DSA") {
      showInputs(inputs);
    } else {
      hideInputs(inputs);
    }
  };

  const handleIsDocsRequiredChange = (args) => {
    let isDocsRequiredKey = args[0]?.key;

    let inputs = ["column-additionalDocsRequested", "column-documentName"];
    if (isDocsRequiredKey === false) {
      hideInputs(inputs);
    } else {
      showInputs(inputs);
    }
  };

  const handleAdditionalDocsChange = (args) => {
    var additionalDocsInput = document.querySelector(
      "[name='appinput-additionalDocsRequested'].form-group",
    );
    var additionalDocsSelect = additionalDocsInput?.vnode.refs.select;
    // console.log(additionalDocsSelect, additionalDocsSelect?.state);

    if (additionalDocsSelect?.state?.values?.length === 0) {
      additionalDocsInput?.vnode.refs.select.select.current
        .querySelector("input")
        .setAttribute("required", true);
    } else {
      additionalDocsInput?.vnode.refs.select.select.current
        .querySelector("input")
        .removeAttribute("required");
    }
    console.log(args);

    var documentNameInput = document.querySelector("#column-documentName");

    let additionalDocsField = modalFields.find(
      (o) => o.name == "additionalDocsRequested",
    );
    const hasOthers = args?.some((obj) => obj.key === "OTHERS");

    if (!hasOthers) {
      documentNameInput.classList.add("d-none");
      documentNameInput?.querySelector("input").removeAttribute("required");
    } else {
      documentNameInput.classList.remove("d-none");
      documentNameInput?.querySelector("input").setAttribute("required", true);
    }
    setFields([...fields]);
  };

  const percentageCalc = (percent, total) => {
    return ((percent / 100) * total).toFixed(2);
  };

  const handleProcessingFeePercentage = (args) => {
    let value = args[0]?.key;
    let loanAmountValue = document.querySelector(
      '[name="sanctionedLoanAmt"]',
    )?.value;

    if (value) {
      let processingFee = percentageCalc(value, loanAmountValue);
      let docCharges = percentageCalc(2, loanAmountValue);
      let platformCharges = percentageCalc(1.4, loanAmountValue);
      let totalCharges =
        Number(processingFee) + Number(docCharges) + Number(platformCharges);

      let GSTFee = percentageCalc(18, totalCharges);
      let totalPF = Number(totalCharges) + Number(GSTFee);

      let netDisburseAmnt = Number(loanAmountValue) - Number(totalPF);

      // console.log({
      //   processingFee,
      //   docCharges,
      //   platformCharges,
      //   totalCharges,
      //   totalPF,
      //   netDisburseAmnt,
      // });

      // console.log(`${value}% of ${loanAmountValue} is ${processingFee}`);

      let processignFeeField = fields.find(
        (field) => field.name === "sanctionedPF",
      );
      processignFeeField.defaultValue = totalPF;

      let netDisbursementAmtField = fields.find(
        (field) => field.name === "netDisbursementAmt",
      );
      netDisbursementAmtField.defaultValue = Math.ceil(Number(netDisburseAmnt));
      setFields([...fields]);
    }
  };

  const getFinalReview = () => {
    props.apis
      .apiUnderWriterGetApplicationReview({
        applicationId: props.urlparams.params.id,
      })
      .then((res) => {
        console.log({ res });
        if (res) {
          let filteredData = {
            customerName: res?.customerName,
            customerApplicationType: res?.customerApplicationType,
            companyname: res?.ApplicationSalaryInfo[0]?.companyname,
            companyCategory: res?.ApplicationSalaryInfo[0]?.companyCategory,
            doj: res?.ApplicationSalaryInfo[0]?.doj,
            cibilScore:
              res?.applicationEquifaxRetailAccountsSummary?.cibilScore,
            applicantDesignation:
              res?.ApplicationSalaryInfo[0]?.applicantJobProfile,
            salaryCreditDate: res?.ApplicationSalaryInfo[0]?.salaryCreditDate,
            avgMonthlyBalance: res?.ApplicationSalaryInfo[0]?.avgMonthlyBalance,
            netMonthlyIncome: res?.ApplicationSalaryInfo[0]?.netMonthlyIncome,
            monthlyNetTakeSalary:
              res?.ApplicationSalaryInfo[0]?.monthlyNetTakeSalary,
            appliedLoanAmount: res?.loanAmount,
            appliedTenure: res?.duration,
            currentObligation: res?.currentObligation,
            sanctionedPF: res?.loanAmount * 0.1,
            sanctionedIRR: res?.sanctionedIRR || 1,
            ...Object.only(res, [
              "residanceStablity",
              "inCityPresence",
              "overallCityPresence",
              "eligibleLoanAmt",
              "sanctionedLoanAmt",
              "sanctionedTenure",
              "sanctionedPctPF",
              "sanctionedRepayType",
              // "sanctionedIRR",
              "overallJobStability",
              "sanctionedNoOfMonth",
              "sanctionedEMIAmt",
              "sanctionedEMIDate",
              "monthlyObligation",
              "customerTVRComment",
              "netDisbursementAmt",
              "channel",
              "dsaName",
              //
              "sanctionedLoanStartDate",
            ]),
            residenceStatus: res?.ApplicationAddressInfo?.[0]?.residenceStatus,
            additionalDocsRequested: res?.additionalDocsRequested,
            telecallerId: res?.telecaller?.profileId || "",
          };
          setReviewdata(filteredData);

          let updatedFields = fields?.map((field) => {
            field.defaultValue = field.defaultValue;
            if (![undefined].includes(filteredData[field.name])) {
              if (field.type == "date") {
                field.defaultValue =
                  filteredData[field.name] && dayjs(filteredData[field.name]);
              } else {
                field.defaultValue = filteredData[field.name];
              }
            }
            if (field.name == "isDocsRequired") {
              let value = res?.additionalDocsRequested;
              if (Array.isArray(value) && value.length === 0) {
                field.defaultValue = false;
              } else {
                field.defaultValue = true;
              }
            }
            if (field.name == "foirCalculation") {
              let currentObligation = res?.currentObligation;
              let monthlyNetTakeSalary =
                res?.ApplicationSalaryInfo[0]?.monthlyNetTakeSalary || 0;
              let value =
                (Number(currentObligation) / Number(monthlyNetTakeSalary)) *
                100;
              field.defaultValue = value?.rounded() || "";
            }
            return field;
          });
          // processing fee will be 10% of the applied loan amount
          let amount = res?.loanAmount * 0.1;
          let processignFeeField = updatedFields.find(
            (field) => field.name === "sanctionedPF",
          );
          processignFeeField.defaultValue = amount;
          console.log({ filteredData, updatedFields });

          setFields([...updatedFields]);

          let restructureData = {};

          if (res?.restructure) {
            setHasRestructureData(true);
            let updatedRestructFields = restructurefields?.map((field) => {
              return {
                ...field,
                defaultValue: res?.restructure[field.name],
              };
            });
            setRestructurefields([...updatedRestructFields]);
          }
        }
      });
  };

  // const updateDefaults = (arr, applicationData) => {
  //   return arr.map((o) => {
  //     let defaultValue = applicationData[o.name] || o.defaultValue || undefined;
  //     if (o.type == "select") {
  //       if (o.getOptions instanceof Function && o.options.length == 0) {
  //         o.options = o.getOptions(applicationData);
  //       }
  //       if (
  //         typeof defaultValue == "string" &&
  //         defaultValue.split(",").length > 1
  //       ) {
  //         defaultValue = defaultValue
  //           .split(",")
  //           .map((key) => o.options.find((o) => o.key == key));
  //       } else if (o.multiple) {
  //         defaultValue = o.options?.filter((o) =>
  //           defaultValue?.includes(o.key)
  //         );
  //       } else {
  //         defaultValue = o.options?.find((o) => o.key == defaultValue);
  //       }
  //     }
  //     return {
  //       ...o,
  //       defaultValue,
  //     };
  //   });
  // };

  const handleRejectReview = (e) => {
    e.preventDefault();
    swal2
      .fire({
        title:
          "Are you sure you want to reject the application?\n Please provide your remarks",
        icon: "info",
        iconColor: "#DE3232",
        html: '<div id="custom-select-container"></div>',
        // input: "select",
        // inputOptions: _enum.REJECTED_REASONS,
        showCancelButton: true,
        confirmButtonColor: "#DE3232",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        customClass: {
          htmlContainer: "rejected_html_container",
          actions: "rejected_actions",
        },
      })
      .then((result) => {
        console.log({ result });
        if (result.isConfirmed) {
          let reasonSelectValue = document.querySelector(
            "[name='appinput-reasons'].form-group",
          )?.vnode.refs.select?.state.values[0]?.key;

          let otherReasonValue =
            document.querySelector("#reasonsremarks").value;

          let payload = {};

          if (reasonSelectValue === "OTHERS") {
            payload.rejectedReason = otherReasonValue;
          } else {
            payload.rejectedReason = reasonSelectValue;
          }

          console.log({ payload });

          props.apis
            .apiUnderWriterRejectApplication(payload, {
              applicationId: props.urlparams.params.id,
            })
            .then((res) => {
              swal2.fire({
                title: "Application Rejected",
                icon: "success",
                iconColor: "#FF4D4D",
                showCancelButton: false,
                timer: 3000,
              });
              navigate(`/app/loanapplications?activetab=${tabStatus}`, {
                replace: true,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    let container = document.getElementById("custom-select-container");
    let root = createRoot(container);
    root.render(
      <Provider store={store}>
        <AppInput
          name="reasons"
          label="Rejected Reasons"
          type="select"
          options={_enum.REJECTED_REASONS}
          onChange={(...args) => handleRejectedReasons(...args)}
          required={true}
        ></AppInput>
        <AppInput
          id="reasonsremarks"
          name="remarks"
          label="Remarks"
          type="textarea"
          required={true}
          outerclass="d-none"
        ></AppInput>
      </Provider>,
    );
  };

  const handleRejectedReasons = (val) => {
    let reason = val[0]?.key;
    console.log({ reason });
    if (reason === "OTHERS") {
      document
        .querySelector('[name="appinput-remarks"]')
        .classList.remove("d-none");
    } else {
      document
        .querySelector('[name="appinput-remarks"]')
        .classList.add("d-none");
    }
  };

  const handleAcceptReview = (e, data) => {
    e.preventDefault();
    let payload =
      data.sanctionedRepayType === "BULLET"
        ? Object.only(data, [
          "residanceStablity",
          "inCityPresence",
          "overallCityPresence",
          "eligibleLoanAmt",
          "sanctionedLoanAmt",
          "sanctionedTenure",
          "sanctionedRepayType",
          "sanctionedIRR",
          "sanctionedPF",
          "sanctionedPctPF",
          "overallJobStability",
          // "monthlyObligation",
          "customerTVRComment",
          "netDisbursementAmt",
          "additionalDocsRequested",
          "channel",
        ])
        : Object.only(data, [
          "residanceStablity",
          "inCityPresence",
          "overallCityPresence",
          "eligibleLoanAmt",
          "sanctionedLoanAmt",
          "sanctionedTenure",
          "sanctionedRepayType",
          "sanctionedNoOfMonth",
          "sanctionedEMIDate",
          "sanctionedIRR",
          "sanctionedPF",
          "sanctionedPctPF",
          "overallJobStability",
          "customerTVRComment",
          "netDisbursementAmt",
          "additionalDocsRequested",
          "channel",
          //
          "sanctionedEMIAmt",
          "sanctionedLoanStartDate",
        ]);
    for (let key in payload) {
      if (
        key.endsWith("Amt") ||
        key.endsWith("Tenure") ||
        key.endsWith("NoOfMonth")
      ) {
        payload[key] = Number(payload[key]);
      }
    }
    let isrequiredInput = document.querySelector(
      "[name='appinput-isDocsRequired'].form-group",
    );
    let isrequiredSelect = isrequiredInput.vnode.refs.select;

    let requiredKey = isrequiredSelect?.state?.values[0]?.key;
    console.log({ requiredKey });

    if (requiredKey == true) {
      if (data?.additionalDocsRequested.includes("OTHERS")) {
        let arr = [
          ...data?.additionalDocsRequested
            .split(",")
            .filter((v) => v !== "OTHERS"),
        ];
        arr.push(data?.documentName?.toUpperCase().replace(/ /g, "_"));
        payload.additionalDocsRequested = arr;
      } else {
        payload.additionalDocsRequested =
          payload.additionalDocsRequested.split(",");
      }
    } else {
      payload.additionalDocsRequested = [];
    }
    payload = {
      ...payload,
      sanctionedIRR: Number(data?.sanctionedIRR),
      sanctionedPF: Number(data?.sanctionedPF),
      sanctionedPctPF: Number(data?.sanctionedPctPF),
      ...(data?.sanctionedRepayType === "EMI"
        ? {
          sanctionedEMIDate: new Date(data?.sanctionedEMIDate).toISOString(),
          sanctionedLoanStartDate: new Date(
            data?.sanctionedLoanStartDate,
          ).toISOString(),
          totalEmiInterest: amortCalcResponse?.totalInterest,
          emiSchedule,
          sanctionedNoOfMonth: Number(data?.sanctionedNoOfMonth),
        }
        : {}),
      docsRequestedCategory: "FINAL_REVIEW",
      telecallerId: data?.telecallerId,
      dsaName: data?.dsaName,
      customerApplicationType: data?.customerApplicationType,
      sanctionedTenure:
        data?.sanctionedRepayType === "EMI"
          ? Number(document.querySelector('[name="tenure"]').value)
          : Number(data?.sanctionedTenure),
      ...(hasRestructureData
        ? {
          restructure: {
            remarks: data?.underwriterRemarks,
          },
        }
        : {}),
    };
    console.log({ data, payload });

    if (payload?.sanctionedIRR !== 1) {
      swal2
        .fire({
          title: "Are you sure you want to change the ROI ? ",
          icon: "info",
          iconColor: "#DE3232",
          showCancelButton: true,
          confirmButtonColor: "#DE3232",
          cancelButtonColor: "##D6DBE7",
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
        })
        .then((result) => {
          if (result.isConfirmed) {
            setFinalReviewPayload(payload);

            props.apis
              .apiUnderWriterSanctionApplication(payload, {
                applicationId: props.urlparams.params.id,
              })
              .then((res) => {
                console.log({ "Application res": res });
                openModal("roi");
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
    } else {
      props.apis
        .apiUnderWriterSanctionApplication(payload, {
          applicationId: props.urlparams.params.id,
        })
        .then((res) => {
          swal2.fire({
            title: "Final Review Submitted",
            icon: "success",
            iconColor: "#FF4D4D",
            showCancelButton: false,
            timer: 3000,
          });
          navigate(`/app/loanapplications?activetab=${tabStatus}`, {
            replace: true,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getAllTelecallers = () => {
    props.apis.apiGetEmployee({ role: "SALES" }).then(({ data, total }) => {
      console.log({ data });

      let formFields = fields?.map((field) => {
        return field;
      });
      let telecallerNameField = formFields.find(
        (field) => field.name === "telecallerId",
      );
      telecallerNameField.options = data.options("profileId", "name");
      console.log({ formFields });
      setFields([...formFields]);
      // setTelecallers(data.options("profileId", "name"));
    });
  };

  const calculateAmortization = (e) => {
    let loanAmountValue = document.querySelector(
      '[name="sanctionedLoanAmt"]',
    )?.value;

    // ROI - sanctionedIRR
    let roiValue = document.querySelector('[name="sanctionedIRR"]')?.value;

    // Loan Start Date - sanctionedLoanStartDate
    let loanStartDateVal = document.querySelector(
      '[name="sanctionedLoanStartDate"]',
    ).value;

    // EMI Start Date - sanctionedEMIDate
    let emiStartDateVal = document.querySelector(
      '[name="sanctionedEMIDate"]',
    ).value;

    // No of Emi's - sanctionedNoOfMonth
    let numberOfEmisVal = document.querySelector(
      '[name="sanctionedNoOfMonth"]',
    ).dataset.invalue;

    let payload = {
      loanAmount: Number(loanAmountValue || null),
      roi: Number(roiValue || null),
      loanStartDate: loanStartDateVal
        ? new Date(loanStartDateVal).toISOString()
        : null,
      emiStartDate: emiStartDateVal
        ? new Date(emiStartDateVal).toISOString()
        : null,
      numberOfEmis: Number(numberOfEmisVal || null),
      penalCharge: 0,
    };

    console.log({ payload });

    props.apis.apiUnderWriterCalculateLoanAmortization(payload).then((res) => {
      console.log({ res });
      if (res) {
        setAmortCalcResponse(res?.data);
        const alteredSchedule = res?.data?.schedule?.map((item) => ({
          emiSequence: item.emiNumber,
          emiRepaymentDate: new Date(item.date).toISOString(),
          interestCalculateDays: item.days,
          interestAmt: item.interest,
          principalAmt: item.principal,
          outstandingAmt: item.outstanding,
          emiAmt: item.emi,
        }));
        setEmiSchedule(alteredSchedule);

        // set tenure value in the form
        document.querySelector('[name="tenure"]').value = res?.data?.tenure;

        // Final EMI Amount - sanctionedEMIAmt
        document.querySelector('[name="sanctionedEMIAmt"]').value =
          res?.data?.fixedEMI;
      }
    });
  };

  useEffect(() => {
    getFinalReview();
    getAllTelecallers();
    let inputs = ["column-dsaName"];
    hideInputs(inputs);
  }, []);

  const getBankLink = () => {
    let link;
    if (frompath === "loanapplications") {
      link = `/app/loanapplications?activetab=${tabStatus}`;
    }
    if (frompath === "dupecheck") {
      link = `/app/dupecheck`;
    }
    return link;
  };

  props.$setNode({
    props,
    reviewdata,
    modalFields,
  });

  return (
    <>
      <AppForm className="mx-auto" onSubmit={handleAcceptReview}>
        <div className="row flex-row card p-4">
          {fields.map((field, i) => (
            <>
              <div
                className={`col-12 col-md-${field?.customcolspan || 4} ${field?.columnClass || ""
                  }`}
                id={`column-${field?.name}`}
              >
                <AppInput
                  {...field}
                // {...(tabStatus !== "inprogress"
                //   ? {
                //       outerclass:
                //         "col-xl-6 mb-3 w-100 d-flex flex-column pe-none fakedisabled",
                //     }
                //   : { outerclass: "col-xl-6 mb-3 w-100 d-flex flex-column" })}
                ></AppInput>
              </div>
              {showAmortCalc && field?.name === "sanctionedEMIDate" && (
                <div className="col-12 mb-4">
                  <div className="row">
                    <div className="col-12 col-md-4">
                      <AppInput
                        name="tenure"
                        type="text"
                        label="Tenure"
                        readOnly={true}
                        disabled={true}
                      ></AppInput>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-end">
                      <button
                        type="button"
                        className="btn btn-primary mb-3"
                        onClick={(...args) => calculateAmortization(...args)}
                      >
                        Calculate
                      </button>
                    </div>
                  </div>

                  <Divider />
                  <Flex wrap gap="small" className="mb-4">
                    <div class="obligation_banner small">
                      <p class="">
                        Principal Amount Disbursed : Rs.{" "}
                        <span>{amortCalcResponse?.loanAmount?.cur()}</span>
                      </p>
                    </div>
                    <div class="obligation_banner small">
                      <p class="">
                        Total Interest : Rs.{" "}
                        <span>{amortCalcResponse?.totalInterest?.cur()}</span>
                      </p>
                    </div>
                  </Flex>
                  <AppTable
                    data={amortCalcResponse?.schedule || []}
                    columns={amortizationColumns}
                    total={amortCalcResponse?.schedule?.length || 0}
                    reorder={true}
                    viewable={false}
                    deletable={false}
                    editable={false}
                  />
                </div>
              )}
            </>
          ))}
        </div>

        {hasRestructureData && (
          <div className="row flex-row card p-4">
            <h2 class="mb-3 fs-4 text-primary">Restructure Loan Details</h2>
            {restructurefields.map((field, i) => (
              <div
                className={`col-6 col-md-4 col-lg-${field?.customcolspan || 4}`}
                key={i}
              >
                <AppInput {...field}></AppInput>
              </div>
            ))}
          </div>
        )}

        {isReadonly ? (
          <div className="nav_container mt-5">
            <button
              type="button"
              onClick={(...args) => props.changeTab(...args, "queries")}
              className="btn btn-primary-lite me-3"
            >
              Back
            </button>
            {tabStatus === "sanctioned" ? (
              <button
                type="button"
                onClick={(...args) =>
                  props.changeTab(...args, "postsanctioneddocs")
                }
                className="btn btn-primary"
              >
                Next
              </button>
            ) : (
              <Link to={getBankLink()} className="btn btn-primary">
                Close
              </Link>
            )}
          </div>
        ) : (
          <div className="nav_container mt-5">
            <Link to={getBankLink()} className="btn btn-primary-lite me-3">
              Cancel
            </Link>
            <button
              className="btn btn-primary-lite me-3"
              type="button"
              onClick={handleRejectReview}
            >
              Reject
            </button>
            <button type="submit" className="btn btn-primary">
              Approve
            </button>
          </div>
        )}
      </AppForm>

      {/* PAN MODAL */}
      <Modal
        show={showRoiModal}
        onHide={closeRoiModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            <div className="col-12 text-center">
              <h3 className="">Enter OTP</h3>
              <div className="d-flex justify-content-center">
                <OTPInput
                  value={otpValue}
                  onChange={(e) => handleOTPChange(e)}
                  separator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                  numInputs={6}
                  shouldAutoFocus={true}
                  isInputNum={true}
                  containerStyle="otp_container small p-0"
                />
              </div>
            </div>
            <div className="col-12 text-center">
              <div className="text-center otp_bottom">
                <span className="me-2">Not received OTP?</span>
                <button
                  className="btn px-0 text-primary fs-5 border-0"
                  disabled={isOtpDisabled}
                  onClick={(e) => resendOTP(e)}
                >
                  Resend
                </button>
              </div>
            </div>
            <div className="col-12 text-center">
              <button
                type="button"
                className="btn btn-primary-lite me-3"
                onClick={(e) => closeRoiModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(...args) => handleOtpVerify(...args)}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(FinalReview);
